import React from 'react';
import { formattedDate } from '../helpers/GenericHelpers';
import { ICONS } from '../constants/Fixtures';

export default class Log extends React.PureComponent {
  displayHeading() {
    if (ICONS[this.props.heading]) {
      return <i className={`fa ${ICONS[this.props.heading]}`} />;
    }
    return <strong>{this.props.heading}</strong>;
  }

  displayMessage() {
    return this.props.message;
  }

  color() {
    switch (this.props.heading) {
      case 'error':
        return 'alert-danger';
      case 'warning':
        return 'alert-warning';
      case 'info':
        return 'alert-info';
      case 'success':
        return 'alert-success';
      default:
        return 'alert-info';
    }
  }

  className = () => {
    let klass = 'log-item alert';
    klass += this.props.color ? ` ${this.color()}` : ' alert-info';
    return klass;
  }

  render() {
    return (<div className={this.className()}>
      <span className="log-type">{this.displayHeading()}</span>
      <div className="log-body">
        {this.props.title ?
          <div className="log-title">{this.props.title}</div>
          : null}
        {this.props.time ?
          <div className="log-time">{formattedDate(this.props.time)} </div>
          : null}
        <div className="log-message">
          {this.displayMessage()}
          {this.props.children}
        </div>
      </div>
    </div>);
  }
}
